import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";

/**
 * 초기 세팅 위저드(`/sysadmin/wizard/init-setting`) API.
 *
 * ⚠️ 같은 폴더의 `wizard.api.js` 와 **다른 화면**이다.
 *  - `wizard.api.js`        → 백엔드 연동 작업자 화면(`/sysadmin/wizard/backend`). 카카오 발신프로필·디벨로퍼 앱.
 *  - `initSetting.api.js`(이것) → 설치 진행자 화면(`/sysadmin/wizard/init-setting`). 초기 세팅 값 입력.
 *
 * 설계: `_ai-runs/2026-09-07_002_install_wizard/001_analysis_and_design.md`
 */

/** [첫번째 화면] 최근 회원가입 역순 계정 목록 + 각 계정의 설치 신청 상태. */
export const getInitSettingAccounts = async () => {
    const res = await fetchApi.get(API_URL.INIT_SETTING_ACCOUNTS)
    return res.data
}

/**
 * [두번째 화면] 진입 시 필요한 값 전부 — 기존 입력값 + 기본 상태 정보 panel 재료.
 *
 * 신청이 아직 없으면 `data.request` 가 null 이다(= 이 계정을 처음 다룬다). 카드 등록 여부·계정 정보는
 * 그래도 채워져서 온다.
 */
export const getInitSettingDetail = async (accountId) => {
    const res = await fetchApi.get(`${API_URL.INIT_SETTING_DETAIL}?accountId=${encodeURIComponent(accountId)}`)
    return res.data
}

/**
 * [두번째 화면] 저장 + (section 4) 액션.
 *
 * @param status 'DRAFT' | 'BIZ_PENDING' | 'BACKEND_READY' | 'CANCELED' | null
 *               null 이면 기존 상태를 유지한다(단순 저장). 그 외 값은 서버가 거절한다.
 */
export const saveInitSettingRequest = async (payload) => {
    const res = await fetchApi.post(API_URL.INIT_SETTING_SAVE, payload)
    return res.data
}

/**
 * (section 4) 신용카드 등록 요청 알림톡 발송.
 *
 * 🔴 **실패도 성공 응답(200)으로 돌아온다** — `data.sent` 로 판정하고 `data.code`·`data.message` 를
 * 화면에 보여줄 것. 서버가 그렇게 만든 이유 = 벤더 거절 사유(예: 템플릿 미등록)를 담당자가 봐야 하고,
 * HTTP 에러로 만들면 공통 에러 처리에 삼켜진다.
 */
export const requestCardRegistration = async (accountId) => {
    const res = await fetchApi.post(API_URL.INIT_SETTING_CARD_REQUEST, {accountId})
    return res.data
}

/** 백엔드 연동 작업자 대기열(status='BACKEND_READY'). */
export const getInitSettingQueue = async () => {
    const res = await fetchApi.get(API_URL.INIT_SETTING_QUEUE)
    return res.data
}

/**
 * 카드 등록 **고유링크** 발급.
 *
 * 🔴 채널에 사업자등록번호가 없으면 서버가 `issued=false` + 안내 문구로 거절한다.
 * 재발급하면 앞서 보낸 링크는 서버에서 잠긴다.
 */
export const issueCardLink = async (accountId) => {
    const res = await fetchApi.post(API_URL.INIT_SETTING_CARD_LINK, {accountId})
    return res.data
}
